import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.settings.general.pricingSettings.title',
    defaultMessage: 'Price group',
    description: 'title of the price group settings on the configuration page',
  },
  feedback: {
    pricingSettingsUpdated: {
      id: 'pages.settings.general.pricingSettings.feedback.pricingSettingsUpdated',
      defaultMessage: 'Price group saved',
      description: 'feedback on the successful update of price group settings',
    },
    pricingSettingsNotUpdated: {
      id: 'pages.settings.general.pricingSettings.feedback.pricingSettingsNotUpdated',
      defaultMessage: 'Price group could not be saved',
      description: 'feedback on the failed update of price group settings',
    },
  },
  editDrawer: {
    title: {
      id: 'pages.settings.general.pricingSettings.editDrawer.title',
      defaultMessage: 'Edit price group',
      description: 'title of the edit price group drawer',
    },
    priceGroupField: {
      label: {
        id: 'properties.priceGroup',
        defaultMessage: 'Price group',
        description: 'label of the is price group field',
      },
    },
    isVatShiftDisabledField: {
      label: {
        id: 'properties.isVatShiftDisabled',
        defaultMessage: 'VAT shift disabled',
        description: 'label of the is shift disabled field',
      },
    },
  },
  actions: {
    edit: {
      id: 'actions.edit',
      defaultMessage: 'Edit',
      description: 'label of the edit button',
    },
  },
};

export default defineMessages(translations);
